import GradientGenerator from "../../../../src/components/GradientGenerator/GradientGenerator";
import * as React from 'react';
export default {
  GradientGenerator,
  React
};